import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'jl-design-system/components/modal/Modal';
import Message from 'jl-design-system/components/message/Message';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { PrimaryLink, SecondaryLink } from 'jl-design-system/elements/link/Link';

// lodash
import isEmpty from 'lodash/isEmpty';
//
import { connect } from 'react-redux';
import OrderItem from '../order-item/OrderItem';
import appConstants from '../../constants/appConstants';
import { removeItems, rebatchOrderAfterBasketEdit } from '../../redux/actions/edit-basket/editBasketActions';

import styles from './unavailable-items-modal.scss';

export const UnavailableItemsModal = (props) => {

  const removeItems = async () => {
    const {
      items,
      rebatchOrderAfterBasketEdit,
      removeItems,
    } = props;

    await removeItems(items.map(item => (item.id)));
    await rebatchOrderAfterBasketEdit();
  };

  const {
    allItemsInBasketUnavailable,
    basketUrl,
    items,
    removeBasketItemsApiCallActive,
    removeItemsFailed,
  } = props;

  if (isEmpty(items)) {
    return null;
  }

  const singleItem = items.length === 1;

  const removeItemButtonText = singleItem ?
    'Remove item and continue' : 'Remove items and continue';

  const topText = singleItem ?
    'Sorry, the following item is not currently available on the John Lewis website.' :
    'Sorry, the following items are not currently available on the John Lewis website.';

  const headerText = singleItem ? 'Item unavailable' : 'Items unavailable';

  return (
    <Modal
      header={headerText}
      hideCloseButton
      isOpen
      rootId={appConstants.ROOT}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
    >
      <p>{topText}</p>

      <div className={styles.itemContainer}>
        {items.map(item => <OrderItem {...item} key={item.id} displayImage hideSubtotals />)}
      </div>

      <p>
        If an item is a bundle, individual items may be available to purchase separately.
        The item{singleItem ? '' : 's'} may be available to purchase in a John Lewis store, or on the John Lewis website at a later date.
      </p>
      <p>We apologise for any inconvenience caused.</p>

      {
        removeItemsFailed &&
        <Message
          title={`Sorry, we couldn't remove the item${singleItem ? '' : 's'}. Please return to basket.`}
          type="error"
        />
      }

      <div className={styles.buttonContainer}>
        {
          (allItemsInBasketUnavailable || removeItemsFailed) &&
          <PrimaryLink
            data-action="handback"
            to={basketUrl}
          >
            Return to basket
          </PrimaryLink>
        }

        {
          (!allItemsInBasketUnavailable && !removeItemsFailed) &&
          <>
            <SecondaryLink
              data-action="handback"
              to={basketUrl}
            >
              Return to basket
            </SecondaryLink>

            <PrimaryButton
              onClick={removeItems}
              submitting={removeBasketItemsApiCallActive}
            >
              {removeItemButtonText}
            </PrimaryButton>
          </>
        }
      </div>
    </Modal>
  );
};

UnavailableItemsModal.propTypes = {
  allItemsInBasketUnavailable: PropTypes.bool,
  basketUrl: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  rebatchOrderAfterBasketEdit: PropTypes.func,
  removeBasketItemsApiCallActive: PropTypes.bool,
  removeItems: PropTypes.func,
  removeItemsFailed: PropTypes.bool,
};

UnavailableItemsModal.defaultProps = {
  allItemsInBasketUnavailable: false,
  basketUrl: '',
  items: undefined,
  rebatchOrderAfterBasketEdit: window.defaultFunc,
  removeBasketItemsApiCallActive: false,
  removeItems: window.defaultFunc,
  removeItemsFailed: false,
};

export function mapStateToProps(state) {
  return {
    allItemsInBasketUnavailable: state.orderForm.unavailableItemInfo?.allItemsInBasketUnavailable,
    basketUrl: state.bff.basketUrl,
    items: state.orderForm.unavailableItemInfo?.unavailableItemsInBasket,
    removeBasketItemsApiCallActive: state.orderForm.removeBasketItemsApiCallActive,
    removeItemsFailed: state.orderForm.removeBasketItemsFailed,
  };
}

export function mapDispatchToProps() {
  return {
    rebatchOrderAfterBasketEdit,
    removeItems,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(UnavailableItemsModal);
